import { Nav } from "react-bootstrap";

export function XtNav(props) {
    return(<Nav {...props}>
        {props.children}
    </Nav>)
}